<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    :class="[ 'icon', `icon--${ name }` ]"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-labelledby="name"
    role="presentation"
  >
    <g :fill="fill">
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Icon',

  props: {
    name: {
      type: String,
      default: null,
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    fill: {
      type: String,
      default: 'currentColor',
    },
    scale: {
      type: Number,
      default: 1,
    },
    customViewBox: {
      type: String
    }
  },
  computed: {
    viewBox() {
      return this.customViewBox || `0 0 ${this.width * this.scale} ${this.height * this.scale}`;
    }
  }
};
</script>
